import moment from 'moment-jalaali';

// تنظیم locale فارسی
moment.loadPersian({ dialect: 'persian-modern' });

/**
 * تبدیل تاریخ میلادی به شمسی (فقط تاریخ)
 * @param {Date|string} date - تاریخ میلادی
 * @returns {string} - تاریخ شمسی به فرمت jYYYY/jMM/jDD
 */
export function toJalali(date) {
  if (!date) return '-';
  const m = moment(date);
  if (!m.isValid()) return '-';
  return m.format('jYYYY/jMM/jDD');
}

/**
 * تبدیل تاریخ میلادی به شمسی با ساعت
 * @param {Date|string} date - تاریخ میلادی
 * @returns {string} - تاریخ شمسی به فرمت jYYYY/jMM/jDD HH:mm
 */
export function toJalaliDateTime(date) {
  if (!date) return '-';
  const m = moment(date);
  if (!m.isValid()) return '-';
  return m.format('jYYYY/jMM/jDD HH:mm');
}

/**
 * تبدیل تاریخ میلادی به شمسی کامل (با نام ماه)
 * @param {Date|string} date - تاریخ میلادی
 * @returns {string} - تاریخ شمسی به فرمت jYYYY jMMMM jDD
 */
export function toJalaliFull(date) {
  if (!date) return '-';
  const m = moment(date);
  if (!m.isValid()) return '-';
  return m.format('jYYYY jMMMM jDD');
}

/**
 * تبدیل تاریخ میلادی به ماه و سال شمسی
 * @param {Date|string} date - تاریخ میلادی
 * @returns {string} - ماه و سال شمسی
 */
export function toJalaliMonthYear(date) {
  if (!date) return '-';
  const m = moment(date);
  if (!m.isValid()) return '-';
  return m.format('jMMMM jYYYY');
}

/**
 * تاریخ شمسی فعلی
 * @returns {string} - تاریخ شمسی فعلی به فرمت jYYYY/jMM/jDD
 */
export function getJalaliNow() {
  return moment().format('jYYYY/jMM/jDD');
}

/**
 * تبدیل تاریخ شمسی به میلادی (برای ذخیره در دیتابیس)
 * @param {string} jalaliDate - تاریخ شمسی به فرمت jYYYY/jMM/jDD
 * @returns {Date|null} - تاریخ میلادی
 */
export function toGregorian(jalaliDate) {
  if (!jalaliDate) return null;
  const parts = jalaliDate.split('/');
  if (parts.length !== 3) return null;
  const m = moment(`${parts[0]}/${parts[1]}/${parts[2]}`, 'jYYYY/jMM/jDD');
  if (!m.isValid()) return null;
  return m.toDate();
}

/**
 * اعتبارسنجی تاریخ شمسی
 * @param {string} jalaliDate - تاریخ شمسی به فرمت jYYYY/jMM/jDD
 * @returns {boolean} - معتبر بودن تاریخ
 */
export function isValidJalali(jalaliDate) {
  if (!jalaliDate) return false;
  const parts = jalaliDate.split('/');
  if (parts.length !== 3) return false;
  const m = moment(`${parts[0]}/${parts[1]}/${parts[2]}`, 'jYYYY/jMM/jDD');
  return m.isValid();
}

/**
 * تبدیل تاریخ میلادی به شمسی برای استفاده در input
 * @param {Date|string} date - تاریخ میلادی
 * @returns {string} - تاریخ شمسی به فرمت jYYYY-jMM-jDD (مناسب برای input)
 */
export function toJalaliInput(date) {
  if (!date) return '';
  const m = moment(date);
  if (!m.isValid()) return '';
  return m.format('jYYYY-jMM-jDD');
}

/**
 * تبدیل تاریخ شمسی از فرمت input به فرمت استاندارد
 * @param {string} jalaliDate - تاریخ شمسی به فرمت jYYYY-jMM-jDD
 * @returns {string} - تاریخ شمسی به فرمت jYYYY/jMM/jDD
 */
export function jalaliInputToStandard(jalaliDate) {
  if (!jalaliDate) return '';
  return jalaliDate.replace(/-/g, '/');
}